// Nakshtra Vidhya logo mark — refined fine-line nakshatra star with double
// celestial orbit rings, inner facet rays, central bindu, and auspicious
// red dots at the cardinal nodes. Spec: /app/design_guidelines.json
export const StarMark = ({ size = 40, className = "" }) => (
  <span
    className={`star-mark ${className}`}
    aria-hidden="true"
    style={{ width: size, height: size }}
  >
    <svg viewBox="0 0 40 40" width={size} height={size} fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="18.5" stroke="#B8912A" strokeWidth="0.8" strokeOpacity="0.45" />
      <circle cx="20" cy="20" r="14" stroke="#B8912A" strokeWidth="0.6" strokeDasharray="1 2" strokeOpacity="0.6" />
      <path
        d="M20 5 L23.8 15.2 L34.3 15.2 L25.8 21.4 L29 31.5 L20 25 L11 31.5 L14.2 21.4 L5.7 15.2 L16.2 15.2 Z"
        stroke="#B8912A"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M20 5 L20 25 M34.3 15.2 L11 31.5 M5.7 15.2 L29 31.5 M16.2 15.2 L25.8 21.4 M23.8 15.2 L14.2 21.4"
        stroke="#B8912A"
        strokeWidth="0.5"
        strokeOpacity="0.4"
      />
      <circle cx="20" cy="20" r="1.2" fill="#B8912A" />
      <circle cx="20" cy="2.2" r="1.2" fill="#B03A2E" />
      <circle cx="37.8" cy="20" r="1.2" fill="#B03A2E" />
      <circle cx="20" cy="37.8" r="1.2" fill="#B03A2E" />
      <circle cx="2.2" cy="20" r="1.2" fill="#B03A2E" />
    </svg>
  </span>
);
